import React from "react";

const CSS = `
.zh-bg{background:#05122E}
.zh-grid{background-image:linear-gradient(rgba(255,255,255,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.05) 1px,transparent 1px);background-size:56px 56px;-webkit-mask-image:radial-gradient(ellipse at 70% 40%,#000 25%,transparent 75%);mask-image:radial-gradient(ellipse at 70% 40%,#000 25%,transparent 75%)}
.zh-orb{position:absolute;border-radius:50%;filter:blur(70px);opacity:.55;animation:zhDrift 12s ease-in-out infinite alternate}
@keyframes zhDrift{to{transform:translate(40px,-30px) scale(1.12)}}
.zh-logo{position:relative;width:112px;height:94px}
.zh-logo img{width:100%;height:100%;object-fit:contain;filter:drop-shadow(0 10px 30px rgba(10,132,255,.55))}
.zh-shine{position:absolute;inset:0;-webkit-mask:url(/zavia-icon.png) center/contain no-repeat;mask:url(/zavia-icon.png) center/contain no-repeat;background:linear-gradient(115deg,transparent 38%,rgba(255,255,255,.95) 50%,transparent 62%);background-size:260% 100%;animation:zhShine 3.6s ease-in-out infinite}
@keyframes zhShine{0%,55%{background-position:160% 0}100%{background-position:-120% 0}}
.zh-reflect{transform:scaleY(-1);opacity:.28;margin-top:4px;-webkit-mask-image:linear-gradient(to top,rgba(0,0,0,.9),transparent 70%);mask-image:linear-gradient(to top,rgba(0,0,0,.9),transparent 70%);height:46px;overflow:hidden}
.zh-reflect img{width:112px;height:94px;object-fit:contain;display:block}
`;

// Fondo profesional del login ZAVIA (azul noche + resplandores azul rey + retícula).
export const ZaviaHeroBg = () => (
  <div className="absolute inset-0 zh-bg overflow-hidden" data-testid="zavia-hero-bg">
    <style>{CSS}</style>
    <div className="zh-orb" style={{ width: 520, height: 520, background: "#0A6CF0", top: -160, right: -80 }} />
    <div className="zh-orb" style={{ width: 380, height: 380, background: "#0A84FF", bottom: -160, left: "30%", animationDelay: "-6s", opacity: 0.35 }} />
    <div className="zh-orb" style={{ width: 300, height: 300, background: "#0047C2", top: 40, left: -120, animationDelay: "-3s", opacity: 0.4 }} />
    <div className="absolute inset-0 zh-grid" />
    <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#0A84FF]/60 to-transparent" />
  </div>
);

// Logo ZAVIA con destello y reflejo.
export const ShiningLogo = () => (
  <div className="mb-8 inline-flex flex-col items-start" data-testid="zavia-shining-logo">
    <style>{CSS}</style>
    <div className="zh-logo"><img src="/zavia-icon.png" alt="ZAVIA" /><div className="zh-shine" /></div>
    <div className="zh-reflect" aria-hidden="true"><img src="/zavia-icon.png" alt="" /></div>
  </div>
);

const SHOTS = ["/hero/1.webp", "/hero/2.webp", "/hero/3.webp", "/hero/4.webp", "/hero/5.webp"];
const VCSS = `
.zv-shot{position:absolute;inset:0;background-size:cover;background-position:center;opacity:0;animation:zvShot 20s linear infinite}
@keyframes zvShot{0%{opacity:0;transform:scale(1.12)}4%{opacity:1}20%{opacity:1}24%{opacity:0;transform:scale(1) translateX(-2%)}100%{opacity:0}}
`;

// Fondo tipo video (5 tomas en movimiento continuo) para la franja superior.
export const HeaderVideoBg = () => (
  <div className="absolute inset-0 overflow-hidden" aria-hidden="true" data-testid="header-video-bg">
    <style>{VCSS}</style>
    {SHOTS.map((src, i) => (
      <div key={src} className="zv-shot" style={{ backgroundImage: `url(${src})`, animationDelay: `${i * 4}s` }} />
    ))}
    <div className="absolute inset-0 bg-gradient-to-r from-[#05122E]/85 via-[#05122E]/35 to-[#05122E]/75" />
  </div>
);

const PHRASES = [
  "Más de 20 colegios nos respaldan",
  "Lo más avanzado en sistema de registro NFC",
  "Más de 7 portales activos",
  "El costo más bajo del segmento",
  "Portales demo",
];
const PCSS = `
.zv-ph{position:absolute;left:0;right:0;top:50%;opacity:0;animation:zvPh 17.5s ease-in-out infinite}
@keyframes zvPh{0%{opacity:0;transform:translateY(-30%);filter:blur(10px);letter-spacing:.12em}
 4%{opacity:1;transform:translateY(-50%);filter:blur(0);letter-spacing:-.01em}
 17%{opacity:1;transform:translateY(-50%);filter:blur(0)}
 20%{opacity:0;transform:translateY(-70%);filter:blur(8px)}100%{opacity:0}}
.zv-ph b{background:linear-gradient(90deg,#fff 0%,#fff 40%,#8EC5FF 50%,#fff 60%,#fff 100%);background-size:250% 100%;-webkit-background-clip:text;background-clip:text;color:transparent;animation:zhShine 3.5s linear infinite}
`;

// Frases que aparecen y desaparecen en bucle, en blanco, sobre el área azul.
export const HeroPhrases = () => (
  <div className="relative flex-1 min-w-0 h-24 sm:h-28 -mt-8" data-testid="hero-phrases">
    <style>{PCSS}</style>
    {PHRASES.map((t, i) => (
      <div key={t} className="zv-ph font-display font-extrabold text-white text-2xl sm:text-3xl lg:text-[2.6rem] leading-tight" style={{ animationDelay: `${i * 3.5}s` }}>
        <b>{t}</b>
      </div>
    ))}
  </div>
);
